import React, { useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import compare from "../images/compare.svg";
import wishlist from "../images/wishlist.svg";
import user from "../images/user.svg";
import cart from "../images/cart.svg";
import menu from "../images/menu.svg";
import { useDispatch, useSelector } from "react-redux";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { getAProduct } from "../features/products/productSlilce";
import { getUserCart } from "../features/user/userSlice";

const Header = () => {
  const dispatch = useDispatch();
  const cartState = useSelector((state) => state?.auth?.cartProducts);
  const authState = useSelector((state) => state?.auth);
  const [total, setTotal] = useState(null);
  const [paginate, setPaginate] = useState(true);
  const productState = useSelector((state) => state?.product?.product);
  const navigate = useNavigate();

  const getTokenFromLocalStorage = localStorage.getItem("customer")
    ? JSON.parse(localStorage.getItem("customer"))
    : null;

  const config2 = {
    headers: {
      Authorization: `Bearer ${getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
        }`,
      Accept: "application/json",
    },
  };

  useEffect(() => {
    dispatch(getUserCart(config2, dispatch));
  }, []);

  const [productOpt, setProductOpt] = useState([]);
  useEffect(() => {
    let sum = 0;
    for (let index = 0; index < cartState?.length; index++) {
      sum = sum + Number(cartState[index].quantity) * cartState[index].price;
      setTotal(sum);
    }
  }, [cartState]);

  useEffect(() => {
    let data = [];
    for (let index = 0; index < productState?.length; index++) {
      const element = productState[index];
      data.push({ id: index, prod: element?._id, name: element?.title });
    }
    setProductOpt(data);
  }, [productState]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
  return (
    <>
      <header className="header-top-strip py-3">
        <div className="container-xxl">
          <div className="row">
            <div className="col-6">
              <p className="text-white mb-0"></p>
            </div>
            <div className="col-6">
              <p className="text-end text-white mb-0">
                Hotline :
                <a className="text-white mx-2" href="tel:+918660891557">
                  +91 8660891557
                </a>
                <a className="text-white" href="tel:+919880572323">
                  +91 9880572323
                </a>
              </p>
            </div>
          </div>
        </div>
      </header>
      <header className="header-upper py-3">
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="col-6 col-md-2 mb-2 mb-md-0">
              <h2>
                <Link className="text-white" to="/">
                  <img src={require('../images/logo192.png')} alt="logo" className="img-fluid" />
                </Link>
              </h2>
            </div>
            <div className="col-12 col-md-5 mb-2 mb-md-0">
              <div className="input-group">
                <Typeahead
                  id="pagination-example"
                  onPaginate={() => console.log("Results paginated")}
                  onChange={(selected) => {
                    navigate(`/product/${selected[0]?.prod}`);
                    dispatch(getAProduct(selected[0]?.prod));
                  }}
                  options={productOpt}
                  paginate={paginate}
                  labelKey={"name"}
                  placeholder="Search for Products here"
                />
                <span className="input-group-text p-3" id="basic-addon2">
                  <BsSearch className="fs-6" />
                </span>
              </div>
            </div>
            <div className="col-6 col-md-5">
              <div className="header-upper-links d-flex align-items-center justify-content-end gap-15">
                <div>
                  <Link
                    to="/wishlist"
                    className="d-flex align-items-center gap-10 text-black"
                  >
                    <img src={wishlist} alt="wishlist" className="header-icon" />
                    <p className="mb-0 d-none d-lg-block" style={{ color: "black" }}>
                      Favourite <br /> wishlist
                    </p>
                  </Link>
                </div>
                <div>
                  <Link
                    to={authState?.user === null ? "/login" : "/my-profile"}
                    className="d-flex align-items-center gap-10 text-white"
                  >
                    <img src={user} alt="user" className="header-icon" />
                    {authState?.user === null ? (
                      <p className="mb-0 d-none d-lg-block" style={{ color: "black" }}>
                        Log in <br /> My Account
                      </p>
                    ) : (
                      <p className="mb-0 d-none d-lg-block" style={{ color: "black" }}>
                        Welcome {authState?.user?.firstname}
                      </p>
                    )}
                  </Link>
                </div>
                <div>
                  <Link
                    to="/cart"
                    className="d-flex align-items-center gap-10 text-black"
                  >
                    <div className="position-relative">
                      <img src={cart} alt="cart" className="header-icon" />
                      <span className="badge bg-white text-dark position-absolute" style={{ top: "-10px", right: "-10px", borderRadius: "50%", padding: "5px 8px", fontSize: "10px" }}>
                        {cartState?.length ? cartState?.length : 0}
                      </span>
                    </div>
                    <div className="d-flex flex-column gap-0">
                      <p className="mb-0 text-dark" style={{ fontSize: "12px", fontWeight: "500" }}>
                        Rs. {!cartState?.length ? 0 : total ? total : 0}
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <header className="header-bottom py-3">
        <div className="container-xxl">
          <div className="row">
            <div className="col-12">
              <div className="menu-bottom d-flex align-items-center gap-30">
                <div className="dropdown d-md-none">
                  <button
                    className="btn btn-secondary dropdown-toggle bg-transparent border-0 gap-15 d-flex align-items-center"
                    type="button"
                    id="mobileMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={menu} alt="menu" />
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="mobileMenuButton">
                    <li><Link className="dropdown-item" to="/">Home</Link></li>
                    <li><Link className="dropdown-item" to="/product">Our Store</Link></li>
                    <li><Link className="dropdown-item" to="/my-orders">My Orders</Link></li>
                    <li><Link className="dropdown-item" to="/blogs">Blogs</Link></li>
                    <li><Link className="dropdown-item" to="/contact">Contact</Link></li>
                    {authState?.user !== null && (
                      <li><button className="dropdown-item" onClick={handleLogout}>LogOut</button></li>
                    )}
                  </ul>
                </div>
                <div className="menu-links d-none d-md-block">
                  <div className="d-flex align-items-center gap-15">
                    <NavLink to="/">Home</NavLink>
                    <NavLink to="/product">Our Store</NavLink>
                    <NavLink to="/my-orders">My Orders</NavLink>
                    <NavLink to="/blogs">Blogs</NavLink>
                    <NavLink to="/contact">Contact</NavLink>
                    {authState?.user !== null ? (
                      <button
                        className="border border-0 bg-transparent text-black text-uppercase"
                        type="button"
                        style={{ backgroundColor: "#f5f5f7" }}
                        onClick={handleLogout}
                      >
                        LogOut
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
